import { Button } from "@/components/ui/button";
import { WarningCircle } from "@phosphor-icons/react";
import { fmtDate } from "./billingUtils";

export function SubscriptionManage({ org, currentPlan, busy, onManage }) {
  return (
    <div className="mb-6 space-y-3">
      {org?.cancel_at_period_end && (
        <div
          data-testid="pending-cancel-notice"
          className="flex items-start gap-2 border border-amber-500/25 bg-amber-500/10 rounded-lg px-5 py-3 text-sm text-amber-300"
        >
          <WarningCircle size={18} weight="fill" className="mt-0.5 shrink-0" />
          <div>
            Your <span className="capitalize font-medium text-white">{currentPlan}</span> subscription is set to cancel on{" "}
            <span className="font-medium text-white">{fmtDate(org.cancel_at)}</span>. You keep full access until then, after which the workspace moves to the free Personal plan. Reactivate anytime from Manage subscription.
          </div>
        </div>
      )}
      <div className="flex items-center justify-between gap-4 border border-white/10 bg-zinc-900 rounded-lg px-5 py-4">
        <div className="text-sm text-zinc-300">
          You're subscribed to <span className="capitalize font-medium text-white">{currentPlan}</span>. Update your card, view invoices, or cancel anytime.
        </div>
        <Button
          data-testid="manage-billing-btn"
          onClick={onManage}
          disabled={busy === "portal"}
          variant="outline"
          className="border-white/15 hover:bg-zinc-800 shrink-0"
        >
          {busy === "portal" ? "Opening…" : "Manage subscription"}
        </Button>
      </div>
    </div>
  );
}
